import React, {Fragment} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";

const FitModelForm = (props) => {
    const {errors, register, setValue, getValues} = props;
    const currentImage = getValues ? getValues('profile_image_url') : null;
    const isEdit = getValues ? !!getValues('id') : false;

    return (
        <Fragment>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Name<span style={{color: "red"}}>*</span></Label>
                        <input name="name" type="text" {...register('name')} className={`form-control ${errors.name ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.name?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Profile Image{!isEdit && <span style={{color: "red"}}>*</span>}</Label>
                        {currentImage && (
                            <div className="mb-2">
                                <img src={currentImage} alt="" style={{width: 64, height: 64, borderRadius: '50%', objectFit: 'cover'}}/>
                            </div>
                        )}
                        <input name="profile_image" type="file" accept="image/*"
                               onChange={(e) => setValue('profile_image', e.target.files)}
                               className={`form-control ${errors.profile_image ? 'is-invalid' : ''}`}/>
                        {isEdit && <small className="text-muted">Leave blank to keep the current photo</small>}
                        <div className="invalid-feedback">{errors.profile_image?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};

export default FitModelForm;
